import "./SoftwareLayout.scss"

export default function SoftwareLayout({ sections }) {
  return (
   <div
  className={`menu-grid software columns-${sections.length}`}
>
  {sections.map((section, idx) => (
    <div className="menu-column" key={idx}>
      <p className="menu-title">{section.title}</p>
      <ul className="menu-list">
        {section.items.map((item, i) => (
          <li key={i}>
            <a href={item.href} className="menu-link">
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  ))}
</div>
);
}
